var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url && _vm.label)?_c('p',{staticClass:"ag-block__cta"},[_c('a',{staticClass:"ag-block__button",attrs:{"href":_vm.url}},[_vm._v(_vm._s(_vm.label))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }